import * as React from "react";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";

import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { AddressSelector } from "../../Partials/AddressSelector/AddressSelector";
import CompanyLookup from "../../Partials/Lookup/CompanyLookup";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";

import { PropertyInterface } from "../../../Entity/Entities/Property/PropertyInterface";
import UnitTypeContainer from "../../../Entity/Entities/Unit/UnitTypeContainer";

import * as uuidV4 from "uuid/v4";

import { NewCoachWrapper } from "./NewCoach/NewCoachWrapper";
import { Title } from "./NewCoach/NewCoachComponents/Title";
import { Subtitle } from "./NewCoach/NewCoachComponents/Subtitle";
import { CoachSummaryTable } from "./NewCoach/NewCoachContents/CoachSummaryTable";

// import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
// import { Entity } from "Casadesk/Entity/Entity";


export class CoachNewPropertyDialog extends Component {
  public state = {
    activeStep: 0,
    skipped: new Set(),
    openCoachCreateNewProperty: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    disableButtonDuringRequest: false,
    errorFields: null,
    selectedProperty: null,
    unit: null,
    unitType: UnitTypeContainer.pickIdFromLabel("Apartment"),
    unitNumber: "",
    squareMeters: "",
    roomNumber: "",
    bedroomNumber: "",
    bathroomNumber: "",
    publicationTitle: "",
    amazonFolderName: uuidV4(),
    address: {
      formattedAddress: ""
    },
    selectedCompany: null,
    property: null,
    isFinishDialogOpen: false,
    searchTextOwner: "",
    focusAfterOwnerCoach: true,
    isSaving: false
    };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    if(this.props.ownerCreateByCoach){
      this.setState({
        selectedCompany: this.props.ownerCreateByCoach
      });
    }
    if(this.props.addressAfterOwnerCoach) {
      this.setState({
        address: this.props.addressAfterOwnerCoach,
        focusAfterOwnerCoach: false
      })
    }
    this.setState({
      openCoachCreateNewProperty: this.props.openCoachCreateNewProperty,
    });
	}

	public componentWillReceiveProps(nextProps) {
    if(nextProps.ownerCreateByCoach){
      this.setState({
        selectedCompany: nextProps.ownerCreateByCoach
      });
    }
    if(nextProps.addressAfterOwnerCoach) {
      this.setState({
        address: nextProps.addressAfterOwnerCoach,
        focusAfterOwnerCoach: false
      })
    }

    this.setState({
      openCoachCreateNewProperty: nextProps.openCoachCreateNewProperty,
    });
  }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openCoachCreateNewProperty: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      disableButtonDuringRequest: false,
      errorFields: null,
      selectedProperty: null,
      unit: null,
      unitType: UnitTypeContainer.pickIdFromLabel("Apartment"),
      unitNumber: "",
      squareMeters: "",
      roomNumber: "",
      bedroomNumber: "",
      bathroomNumber: "",
      publicationTitle: "",
      amazonFolderName: uuidV4(),
      address: {
        formattedAddress: ""
      },
      selectedCompany: null,
      property: null,
      isFinishDialogOpen: false,
      searchTextOwner: "",
      focusAfterOwnerCoach: true
    });
  }

  public onClosePropertyCoach = () => {
    this.props.onClosePropertyCoach.call(this, this.state.property);

    setTimeout(() => {this.clearState()}, 100);
    this.clearBackEndErrors();
  }

  /* Logic for open other coaches */
  public openPropertyOwnerCoachDialog = () => {
    if(this.props.openPropertyOwnerCoachDialog){
      this.props.openPropertyOwnerCoachDialog.call(this, this.state.searchTextOwner, this.state.address);
      this.setState({
        searchTextOwner: ""
      })
    }
  }

  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();

    if(activeStep === steps.length - 1) { // it is last step
      if(this.state.errorFields?.length > 0){
        this.setState({
          isFinishDialogOpen: true
        });
      } else {
        this.onClosePropertyCoach();
      }
    } else {
      switch (activeStep) {
        case 0:
          return this.startStep1();
        case 1:
          return this.startStep2();
        case 2:
          return this.startStep3();
        case 3:
          return this.plusOneStep();
      }
    }
  };

  public handleBack = () => {
    const { activeStep } = this.state;

    if(activeStep === 0) {
      if(typeof this.props.openFirstStep !== "undefined"){
        this.clearFieldsError();
        this.clearBackEndErrors();
        this.clearState();
        return this.props.openFirstStep.call(this);
      }
    } else {
      this.clearFieldsError();
      return this.setState({
        activeStep: activeStep - 1,
      });
    }
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [
      this.trans("coach/newproperty-step/first-step"),
      this.trans("coach/newproperty-step/second-step"),
      this.trans("coach/newproperty-step/third-title"),
      this.trans("coach/newproperty-step/forth-title"),
    ];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      case 2:
        return this.stepContent(step);
      case 3:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.secondStepDetails()}
        {step === 2 && this.thirdStepDetails()}
        {step === 3 && this.forthStepDetails()}
      </div>
    )
  }


  // Steppers components content
  public firstStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/newproperty-step/first-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/newproperty-step/first-subtitle")}
        />
        <div>
          <CompanyLookup
            {...this.props}
            id="companyId"
            name="companyId"
            className="scroll-to-companyId"
            isInlineBlock={true}
            width="100%"
            containerWidth="500px"
            styleInModal={"styleInModal"}
            autoSelectId={this.state.selectedCompany && this.state.selectedCompany.id}
            ref="CompanyLookup"
            floatingLabelText={this.trans("dropdown-searchforowner-label2")}
            labelText={this.trans("dropdown-owner-label2")}
            searchText={this.state.selectedCompany ? this.state.selectedCompany.displayName : ""}
            onSelect={this.selectCompany}
            onClear={this.clearCompany}
            onChange={this.changeNameForOwner}
            selectEntityName={this.selectEntityName}
            noResultText={this.trans("dropdown-owner-notfound")}
            error={this.getErrorFor("companyId")}
            templateFor={"owner"}
            shouldOpenCoachModal={true}
            hideClickThroughLink={true}
            openPropertyOwnerCoachDialog={this.openPropertyOwnerCoachDialog}
            disableEntityCreation={true}
          />
        </div>
      </div>
    )
  }

  public secondStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/newproperty-step/second-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/newproperty-step/first-info1", {ownerDisplayName: this.state?.selectedCompany?.displayName})}
        />
        <div style={{width: "500px"}}>
          <AddressSelector
            {...this.props}
            // autoFocus={this.state.focusAfterOwnerCoach}
            id="address"
            name="address.googlePlaceId"
            className="scroll-to-address"
            styleInModal={"styleInModal"}
            searchText={this.state?.address?.formattedAddress ? this.state.address.formattedAddress : null}
            selectedAddress={this.state.address}
            onSelect={this.sync.bind(this, this.syncronizers.VALUE, "address")}
            onClear={this.sync.bind(this, this.syncronizers.VALUE, "address", { formattedAddress: "" })}
            required={true}
            // showListAfterFocus={this.state.focusAfterOwnerCoach}
            error={this.getErrorFor("address.googlePlaceId")}
          />
        </div>
      </div>
    )
  }

  public thirdStepSummary = () => {
    let summaryArr = [
      {
        label: this.trans("coach/newproperty-step/third-address/label"),
        value: this.state?.address?.formattedAddress
      },
      {
        label: this.trans("coach/newproperty-step/third-owner/label"),
        value: this.state.selectedCompany?.displayName
      }
    ];

    return summaryArr;
  }

  public thirdStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <Title
          title={this.trans("coach/newproperty-step/third-title")}
        />
        <Subtitle
          subtitle={this.trans("coach/general-forelast-create-subtitle-dutch-het", {entity: this.trans("title-address").toLowerCase()})}
        />
        <CoachSummaryTable
          tableRows={this.thirdStepSummary()}
        />
      </div>
    )
  }

  public forthStepDetails = () => {
    return (
      <div className="coach-content-wrapper">
        <div>
          <Title
            title={this.trans("result")}
            style={{paddingBottom: "30px"}}
          />
          <div style={{display: "flex", justifyContent: "center", marginBottom: "10px"}}>
            {this.image.getAvatar("success", { size: 62 })}
          </div>
          <Subtitle
            subtitle={this.trans("coach/general-summary-create-subtitle-dutch-het", {entity: this.trans("title-address").toLowerCase()})}
          />
        </div>
        {!this.state.property &&
          <div>
            <div className="info-text">
              {`${this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo1")}`}
            </div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map( item => {
                  let transField = this.trans(`coach-error-${item}`)

                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", {field: transField})}</div>
                })
              }
            </div>
            <div className="info-text">
              {this.trans("coach/propertyowner-scenario/company-step/fourth-errorinfo2")}
            </div>
          </div>
        }
      </div>
    );
  }

  //Funcionality for steps
  public startStep1 = () => {
    return this.propertyStartStepFirst();
  }

  public startStep2 = () => {
    return this.propertyStartStepSecond();
  }

  public startStep3 = () => {
    return this.propertyStartStepThird();
  }

  public startStep4 = () => {
    return this.propertyStartStepThird();
  }

  //Methods for step logic
  public propertyStartStepFirst = () => {
    this.plusOneStep();
  }

  public propertyStartStepSecond = () => {
    this.plusOneStep();
  }

  public propertyStartStepThird = () => {
    this.setState({
      isSaving: true
    });

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_PROPERTY_CREATE_START,
        payload: {
          property: {
            address: { ...this.state.address },
            companyId: !this.state.selectedCompany ? null : this.state.selectedCompany.id,
            managerId: null,
            amazonFolderName: this.state.amazonFolderName,
            note: "",
            isDefaultUnit: false,
            chargeTemplatesIds: null,
            contactInformationOfAssociation: "",
            associationOwnerId: null
          },
          hideSnackbar: true
        },
        onSuccess: (property: PropertyInterface) => {
          this.setState({
            property: property,
            errorFields: [],
            isSaving: false
          })
          this.plusOneStep();
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            hasModifiedData: true,
            errorFields: err.fields
          });
        }
      });
    });
  }

  public propertyStartStepForth = () => {
    this.plusOneStep();
  }

  //Methods
  public selectCompany = (company: CompanyInterface, isManuallySelected: boolean): void => {
    this.setState({
      selectedCompany: company,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData
    });
  }

  public selectEntityName = (name, type) => {
    this.setState({
      defaultCompanyName: type === "owner" ? name : "",
      defaultPoaCompanyName: type === "company" ? name : "",
    })
  }

  public clearCompany = (): void => {
    this.setState({
      hasModifiedData: true,
      selectedCompany: null
    });
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
    })
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }

  public changeNameForOwner  = (value) => {
    this.setState({
      searchTextOwner: value
    })
  }

  public render() {
    const steps = this.getSteps();
    return (
      <div>
        <NewCoachWrapper
          state={this.state}
          steps={steps}
          oldCoach={true}
          content={(activeStep) => this.getStepContent(activeStep)}
          openCoach={this.state.openCoachCreateNewProperty}
          onCloseCoach={this.onClosePropertyCoach}
          onPageChange={(activeStep, isNext) => {
            isNext && this._handlePageChange(activeStep);
            !isNext && this.setState({activeStep, isDisabled: false})
          }}
          showBackButton={this.state.activeStep !== steps.length - 1}
          disabledNext={
            (this.state.activeStep === 0 && !this.state.selectedCompany) ||
            (this.state.activeStep === 1 && !this.state.address?.formattedAddress)
          }
        />

        <PageTransition isSaving={this.state.isSaving} />

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isFinishDialogOpen}
          title={this.trans("title-attention") + "!"}
          content={this.trans("coach-loseinformation/info")}
          positiveButtonLabel={this.trans("dialog-button/continue")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => this.setState({ isFinishDialogOpen: false }, this.onClosePropertyCoach)}
          onDiscard={() => this.setState({ isFinishDialogOpen: false, considerPaidProcess: false }) }
        />
      </div>
    );
  }
}
